export enum OutcomeResults {
  Yes = 'Y',
  No = 'N',
  Refer = 'R',
  Unset = 'Z',
}
